export const getHighestRole = (): string => {
    const roles = localStorage.getItem("roles") || "";
    if(roles.includes("ADMIN")) return "ADMIN";
    if(roles.includes("USER")) return "USER";
    if(roles.includes("WORKER")) return "WORKER";
    return "";
}

export const hasRole = (role: string): boolean => {
    const roles = localStorage.getItem("roles") || "";
    return roles.includes(role);
}